import React, { useEffect, useMemo, useState } from "react";
import { fetchGiftBySlug, fetchGiftAddons, addGiftToCart } from "../services/GiftServices";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import "./GiftDetail.css";
import { useNavigate } from "react-router-dom";

const WHATSAPP_PHONE = process.env.REACT_APP_WHATSAPP_PHONE || "919262718449";

export default function GiftDetail() {
  const { slug } = useParams();
  const [gift, setGift] = useState(null);
  const [qty, setQty] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const g = await fetchGiftBySlug(slug);
      setGift(g);
    })();
  }, [slug]);

  const total = useMemo(() => {
    if (!gift) return 0;
    const price = gift.discountedPrice ? Number(gift.discountedPrice) : Number(gift.basePrice);
    return price * qty;
  }, [gift, qty]);

  const submit = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Please login to add gifts to your cart.");
      navigate("/login");
      return;
    }
    try {
      const payload = {
        type: "GIFT",
        giftProductId: gift.id,
        quantity: qty,
      };
      await addGiftToCart(payload);
      toast.success("Added to cart! 🎁");
    } catch (e) {
      toast.error(e.response?.data?.message || "Failed to add");
    }
  };

  const handleWhatsApp = () => {
    const msg = encodeURIComponent(
      `Hi, I want to customize the gift "${gift?.name}". Please assist me.`
    );
    window.open(`https://wa.me/${WHATSAPP_PHONE}?text=${msg}`, "_blank");
  };

  if (!gift) return <div className="loading">Loading…</div>;

  return (
    <div className="gift-detail">
      <div className="gallery">
        <motion.img src={gift.imageUrl} alt={gift.name}
          initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} />
      </div>

      <div className="info">
        <h1>{gift.name}</h1>
        <p className="desc">{gift.description}</p>

        <div className="line">
          <span className="lab">Price</span>
          <span>
            ₹{gift.discountedPrice ? gift.discountedPrice : Number(gift.basePrice).toFixed(2)}
            {gift.discountPercent > 0 && (
              <span style={{ color: "red", marginLeft: "8px", fontSize: "0.95em" }}>
                <del>₹{Number(gift.basePrice).toFixed(2)}</del> ({gift.discountPercent}% OFF)
              </span>
            )}
          </span>
        </div>

        <div className="qty-line">
          <button onClick={() => setQty(q => Math.max(1, q - 1))}>−</button>
          <span>{qty}</span>
          <button onClick={() => setQty(q => q + 1)}>+</button>
          <div className="spacer" />
          <div className="total">Total: <strong>₹{total.toFixed(2)}</strong></div>
        </div>

        <button className="btn-add" onClick={submit}>Add to Cart</button>
        <button className="btn-contact" onClick={handleWhatsApp} style={{marginTop: 12, background: "#25D366", color: "#fff"}}>
          Need Customization? Contact Us
        </button>
      </div>
    </div>
  );
}